module.exports = __webpack_public_path__ + "static/media/testimonial-flood.e7e130be.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/resources/img/hero/testimonial-flood.jpg
// module id = 1246
// module chunks = 0